"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  hu: {
    com: {
      components: {
        headerCartButton: {
          cartButton: 'kosár'
        }
      },
      productDetail: {
        parameters: {
          title: 'mûszaki adatok'
        }
      },
      productAvailability: {
        format: {
          available: 'raktáron',
          moreThanX: ' {min} minimum feletti mennyiség raktáron',
          exactCount: '{value} termék raktáron',
          notAvailable: 'nincs raktáron'
        }
      },
      imageGallery: {
        thumbnailsMore: '+ {number} több'
      },
      relatedProducts: {
        title: 'kapcsolódó termékek'
      },
      productAccessories: {
        title: 'kiegészítõ termékek'
      },
      productDetailImageGallery: {
        noImage: 'nincs kép'
      },
      productAvailabilityFieldPreviewWithPopup: {
        button: 'Mikor kaphatom meg a terméket ?'
      }
    }
  }
};
var _default = messages;
exports.default = _default;